import React, { useEffect, useState } from 'react';
import { CircularProgress, Container } from '@mui/material';
import './SplashScreen.css'; // Import your CSS file for styles
import QuickTixSplash from "../../Images/GX_Logo_Black_No_Bg.png";

const SplashScreen = () => {
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Simulate a delay for the splash screen
    const timer = setTimeout(() => {
      setLoading(false);
    }, 1000); // Adjust timeout as needed (3000 ms = 3 seconds)

    return () => clearTimeout(timer); // Cleanup on unmount
  }, []);

  return (
    <Container className="splash-container" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>  
      <img src={QuickTixSplash} alt="QuickTix Splash" className={`splash-image ${loading ? 'fade-in' : 'fade-out'}`} />
    </Container>
  );
};

export default SplashScreen;
